import { FunctionComponent, memo, useEffect } from "react";


interface PaginationProps  {
    pagesCount: number,
    activePage: number,
    aroundElements?: number,
    isShow?: boolean
    changePaginationPage: (page:number) => void
}
 
const Pagination: FunctionComponent<PaginationProps> = memo((props: PaginationProps) => {
    let {pagesCount, activePage, aroundElements = 1, isShow = true, changePaginationPage} = props

    let totalPaginationElements = aroundElements * 4 + 1;
    let minIndex = aroundElements * 2 + 1;
    let maxIndex = pagesCount - minIndex;

    let paginationClasses = `pagination ${!isShow && 'hide'}`;

    let links = [];
    for ( let i = 1; i <= pagesCount; i++) links.push(i);

    const renderPageLink = (page: number, isActive: boolean) => {
        return <a key={page} className={`${isActive ? "active": ""}`} onClick={()=>{changePaginationPage(page)}} >{page}</a> 
    }

    const renderLeftSidePagination = (limit: number) => {
        let leftSide:JSX.Element[] = [];
        for ( let i = 1; i <= limit; i++){
            leftSide.push(renderPageLink(i, i === activePage))
        }
        return leftSide.map(it => it)
    }

    const renderRightSidePagination = (limit: number) => {
        let rightSide:JSX.Element[] = [];
        for ( let i = limit; i <= pagesCount; i++){
            rightSide.push(renderPageLink(i, i === activePage))
        }
        return rightSide.map(it => it)
    }

    const renderMiddlePagination = (from:number, to: number) => {
        let middletSide:JSX.Element[] = [];
        for ( let i = from; i <= to; i++){
            middletSide.push(renderPageLink(i, i === activePage))
        }
        return middletSide.map(it => it)
    }

    if(pagesCount <= totalPaginationElements) {
        return  (
            <div className={paginationClasses}>
                {links.map(i => renderPageLink(i, i === activePage))}
            </div>
        )
    } else {
        if(activePage < minIndex){
            return  (
                <div className={paginationClasses}>
                    {renderLeftSidePagination(minIndex)}
                    <span>...</span>
                    {renderRightSidePagination(pagesCount - aroundElements + 1)}
                </div>
            )
        }
        if(activePage > (maxIndex + 1)){
            return  (
                <div className={paginationClasses}>
                    {renderLeftSidePagination(aroundElements)}
                    <span>...</span>
                    {renderRightSidePagination(maxIndex + 1)}
                </div>
            )
        }
        return  (
            <div className={paginationClasses}>
                {renderLeftSidePagination(aroundElements)}
                {(activePage - aroundElements) > aroundElements + 1 ? <span>...</span> : <></>}
                {renderMiddlePagination(activePage - aroundElements, activePage + aroundElements)}
                {(activePage + aroundElements - 1) < pagesCount - aroundElements ? <span>...</span> : <></>}
                {renderRightSidePagination(pagesCount - aroundElements + 1)}
            </div>
        )
    } 
})
 
export default Pagination;